import React from "react";
import { Line } from "react-chartjs-2";
// import {
//   FaCcVisa,
//   FaCcMastercard,
//   FaCcAmex,
//   FaGooglePay,
//   FaAmazonPay,
//   FaMoneyBillWave,
//   FaUniversity,
//   FaWallet,
//   FaMobileAlt,
//   FaCreditCard,
// } from "react-icons/fa";
// import { SiPaytm, SiPhonepe } from "react-icons/si";
// import { MdAccountBalance, MdPayment } from "react-icons/md";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import {
  FiShoppingBag,
  FiDollarSign,
  FiUsers,
  FiDownload,
} from "react-icons/fi";
import { CiWallet } from "react-icons/ci";
import { useAuth } from "../../context/AuthContext";

// const PaymentIconMapper = {
//   // Card types
//   visa: { icon: FaCcVisa, color: "#1A1F71" },
//   mastercard: { icon: FaCcMastercard, color: "#EB001B" },
//   maestro: { icon: FaCreditCard, color: "#0099DF" },
//   rupay: { icon: FaCreditCard, color: "#097939" },
//   amex: { icon: FaCcAmex, color: "#006FCF" },

//   // Wallets
//   paytm: { icon: SiPaytm, color: "#00BAF2" },
//   phonepe: { icon: SiPhonepe, color: "#5F259F" },
//   gpay: { icon: FaGooglePay, color: "#4285F4" },
//   googlepay: { icon: FaGooglePay, color: "#4285F4" },
//   amazonpay: { icon: FaAmazonPay, color: "#FF9900" },
//   wallet: { icon: FaWallet, color: "#FF5A29" },

//   // UPI
//   upi: { icon: FaMobileAlt, color: "#097939" },

//   // Other
//   netbanking: { icon: MdAccountBalance, color: "#0CC763" },
//   bank: { icon: FaUniversity, color: "#0CC763" },
//   cod: { icon: FaMoneyBillWave, color: "#0C9CFC" },
//   cash: { icon: FaMoneyBillWave, color: "#0C9CFC" },

//   // Default
//   default: { icon: MdPayment, color: "#735DFF" },
// };

// const getPaymentIconConfig = (paymentMethod) => {
//   const method = paymentMethod.toLowerCase();

//   for (const [key, config] of Object.entries(PaymentIconMapper)) {
//     if (method.includes(key)) {
//       return config;
//     }
//   }

//   return PaymentIconMapper.default;
// };

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const statsData = [
  {
    id: 1,
    title: "Total No. of Agents",
    value: "50",
    link: "View all Leads",
    percentage: "0.29%",
    isPositive: true,
    icon: FiShoppingBag,
    iconBg: "#735DFF",
  },
  {
    id: 2,
    title: "Total no. of Builders/Owners",
    value: "134",
    link: "complete revenue",
    percentage: "3.45%",
    isPositive: false,
    icon: FiDollarSign,
    iconBg: "#FF5A29",
  },
  {
    id: 3,
    title: "Total no. of Projects",
    value: "3,000",
    link: "Total page views",
    percentage: "11.54%",
    isPositive: true,
    icon: FiUsers,
    iconBg: "#0CC763",
  },
  {
    id: 4,
    title: "Total no. of property",
    value: "20,000",
    link: "Total profit earned",
    percentage: "0.18%",
    isPositive: true,
    icon: CiWallet,
    iconBg: "#0C9CFC",
  },
];

const recentActivities = [
  {
    id: 1,
    date: "01.08.2025",
    name: "Jane Smith (2 BHK, Kalinga Nagar)",
    action: "Property Visit",
    color: "#735DFF",
  },
  {
    id: 2,
    date: "01.08.2025",
    name: "Jane Smith (2 BHK, Kalinga Nagar)",
    action: "Close Deal",
    color: "#0CC763",
  },
  {
    id: 3,
    date: "01.08.2025",
    name: "Jane Smith (2 BHK, Kalinga Nagar)",
    action: "Meet Up",
    color: "#FF4523",
  },
  {
    id: 4,
    date: "01.08.2025",
    name: "Jane Smith (2 BHK, Kalinga Nagar)",
    action: "Brokerage Discussion",
    color: "#FFC053",
  },
  {
    id: 5,
    date: "01.08.2025",
    name: "Builder Meeting",
    action: "",
    color: "#FFC053",
  },
];

// const recentTransactions = [
//   {
//     id: 1,
//     mode: "Paypal ****2783",
//     type: "Online Transaction",
//     amount: "$1,234.78",
//     date: "Nov 22,2024",
//     icon: "₽",
//     iconBg: "#735DFF",
//   },
//   {
//     id: 2,
//     mode: "Digital Wallet",
//     type: "Online Transaction",
//     amount: "$623.99",
//     date: "Nov 22,2024",
//     icon: "⊡",
//     iconBg: "#FF5A29",
//   },
//   {
//     id: 3,
//     mode: "Mastro Card ****7893",
//     type: "Card Payment",
//     amount: "$1,324",
//     date: "Nov 21,2024",
//     icon: "◉",
//     iconBg: "#0CC763",
//   },
//   {
//     id: 4,
//     mode: "Cash On Delivery",
//     type: "Pay On Delivery",
//     amount: "$1,123.49",
//     date: "Nov 20,2024",
//     icon: "💵",
//     iconBg: "#0C9CFC",
//   },
//   {
//     id: 5,
//     mode: "Visa Card ****2563",
//     type: "Card Payment",
//     amount: "$1,289",
//     date: "Nov 18,2024",
//     icon: "V",
//     iconBg: "#FFC053",
//   },
// ];

const chartData = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Delivered",
      data: [30, 35, 32, 40, 45, 50, 65, 55, 60, 70, 50, 85],
      borderColor: "#735DFF",
      backgroundColor: "rgba(115, 93, 255, 0.1)",
      fill: true,
      tension: 0.4,
    },
    {
      label: "Pending",
      data: [45, 40, 50, 55, 48, 60, 70, 50, 65, 75, 65, 55],
      borderColor: "#FF5A29",
      backgroundColor: "rgba(255, 90, 41, 0.1)",
      fill: true,
      tension: 0.4,
    },
  ],
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
    },
  },
};

const StatCard = ({
  title,
  value,
  link,
  percentage,
  isPositive,
  icon: Icon,
  iconBg,
}) => (
  <div className="bg-background-card rounded-lg p-4 sm:p-5 shadow-sm">
    <div className="flex justify-between items-start mb-4">
      <div>
        <p className="text-text-primary font-medium text-sm mb-2">{title}</p>
        <h3 className="text-2xl font-semibold text-text-primary">{value}</h3>
      </div>
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center"
        style={{ backgroundColor: iconBg }}
      >
        <Icon className="text-white text-xl size-7" />
      </div>
    </div>
    <div className="flex justify-between items-center">
      <button className="text-text-muted capitalize leading-relaxed underline underline-offset-2 cursor-pointer text-sm hover:text-primary">
        {link}
      </button>
      <span
        className={`text-sm font-semibold ${
          isPositive ? "text-status-success" : "text-status-danger"
        }`}
      >
        {percentage}
      </span>
    </div>
  </div>
);

const RecentActivityItem = ({ date, name, action, color }) => (
  <div className="flex items-center py-3 gap-2">
    {/* Date and Dot */}
    <div className="flex items-center self-start gap-2 min-w-fit">
      <span className="text-text-secondary text-xs whitespace-nowrap">
        {date}
      </span>
      <div
        className="w-3 h-3 rounded-full border-[3px] flex-shrink-0"
        style={{ borderColor: color }}
      />
    </div>

    {/* Text Content */}
    <div className="flex-1 min-w-0">
      <p className="text-text-primary text-xs font-medium truncate">{name}</p>
      {action && (
        <button className="text-xs truncate font-medium" style={{ color }}>
          {action}
        </button>
      )}
    </div>
  </div>
);

// const TransactionItem = ({ mode, type, amount, date }) => {
//   const iconConfig = getPaymentIconConfig(mode);
//   const IconComponent = iconConfig.icon;
//   return (
//     <div className="flex items-center justify-between w-full py-3">
//       <div className="flex items-center gap-3">
//         <div
//           className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold"
//           style={{ backgroundColor: iconConfig.color }}
//         >
//           <IconComponent className="w-5 h-5" />
//         </div>
//         <div>
//           <p className="text-text-primary text-sm font-medium">{mode}</p>
//           <p className="text-text-muted text-xs">{type}</p>
//         </div>
//       </div>
//       <div className="text-right">
//         <p className="text-text-primary text-sm font-semibold">{amount}</p>
//         <p className="text-text-muted text-xs">{date}</p>
//       </div>
//     </div>
//   );
// };

const SuperAdminDashboard = () => {
  const [activeTab, setActiveTab] = React.useState("Day");
  const { user } = useAuth();

  return (
    <div className="min-h-screen font-quicksand bg-background py-3 sm:py-4 md:py-6 pl-3 sm:pl-4 md:pl-6 pr-2 sm:pr-3 md:pr-4">
      {/* Header */}
      <div className="mb-4 cursor-default font-poppins">
        <h1 className="text-2xl font-semibold text-text-primary mb-1">
          Welcome Back, {user?.fullName || "Mahi"}
        </h1>
        <p className="text-text-muted text-sm">
          Let's dive in and get things done.
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        {statsData.map((stat) => (
          <StatCard key={stat.id} {...stat} />
        ))}
      </div>

      {/* Main Content Grid - Improved Responsiveness */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
        {/* Recent Activity - Takes full width on mobile, 1/3 on xl */}
        <div className="xl:col-span-3 bg-white rounded-lg pb-5 shadow-sm">
          <h2 className="text-xl px-5 font-bold text-text-primary py-4 border-b border-gray-200/70">
            Recent Activity
          </h2>
          <div className="px-5">
            <div className="space-y-1">
              {recentActivities.slice(0, 4).map((activity) => (
                <RecentActivityItem key={activity.id} {...activity} />
              ))}
            </div>
          </div>
        </div>

        {/* Lead Statistics - Takes full width on mobile, 1/2 on xl */}
        <div className="xl:col-span-6 bg-white rounded-lg pb-5 shadow-sm">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center px-5 py-3 border-b border-gray-200/70 gap-4">
            <h2 className="text-xl font-bold text-text-primary">
              Lead Statistics
            </h2>
            <div className="flex flex-wrap items-center rounded-lg">
              {["Day", "Week", "Month", "Year"].map((tab, index, arr) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 text-sm font-medium transition-colors 
                  ${
                    activeTab === tab
                      ? "bg-primary text-white"
                      : "text-primary bg-primary/20"
                  } 
                  ${
                    index !== arr.length - 1 ? "border-r border-primary/50" : ""
                  } 
                  ${index === 0 ? "rounded-l-md" : ""} 
                  ${index === arr.length - 1 ? "rounded-r-md" : ""}`}
                >
                  {tab}
                </button>
              ))}

              <button className="px-4 ml-2 py-2 rounded-md text-sm font-medium text-text-secondary bg-gray-100 hover:bg-gray-200 flex items-center gap-2 transition-colors duration-100">
                Export <FiDownload />
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-6 mt-6 mb-5 px-5">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-[#735DFF]" />
              <span className="text-sm text-text-secondary">Delivered</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-gray-300" />
              <span className="text-sm text-text-secondary">Pending</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-[#FF5A29]" />
              <span className="text-sm text-text-secondary">Cancelled</span>
            </div>
          </div>

          <div className="h-64 sm:h-80 px-4">
            <Line data={chartData} options={chartOptions} />
          </div>
        </div>

        {/* Recent Transactions - Takes full width on mobile, 1/3 on xl */}
        {/* <div className="xl:col-span-3 bg-white rounded-lg pb-5 shadow-sm">
          <h2 className="text-xl px-5 font-bold text-text-primary py-4 border-b border-gray-200/70 flex justify-between items-center">
            <span>Recent Transactions</span>
            <button className="text-text-muted/80 text-xs hover:underline">
              View All
            </button>
          </h2>

          <div className="px-5">
            <div className="flex w-full justify-between font-semibold py-3 border-b border-gray-200/70">
              <div>Payment Mode</div>
              <div>Amount Paid</div>
            </div>
            <div className="flex flex-col space-y-2 w-full">
              {recentTransactions.slice(0, 6).map((transaction) => (
                <TransactionItem key={transaction.id} {...transaction} />
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
